import {i18n} from '@yourcoach/i18n';

import type {ProgramDurationUnit} from './types';

interface DurationUnitEnum {
  DAY: ProgramDurationUnit;
  MONTH: ProgramDurationUnit;
  WEEK: ProgramDurationUnit;
}

export const ProgramDurationUnitEnum: DurationUnitEnum = {
  DAY: {
    id: 'day',
    max: 365,
    multiplier: 1,
  },
  MONTH: {
    id: 'month',
    max: 12,
    multiplier: 30,
  },
  WEEK: {
    id: 'week',
    max: 52,
    multiplier: 7,
  },
};

Object.keys(ProgramDurationUnitEnum).forEach(key => {
  const unit: ProgramDurationUnit = ProgramDurationUnitEnum[key];

  unit.toString = count =>
    /**
     * @i18n_parser
     * t('shared:program.duration_unit.day', {count})
     * t('shared:program.duration_unit.month', {count})
     * t('shared:program.duration_unit.week', {count})
     */
    i18n.t(`shared:program.duration_unit.${unit.id}`, {
      count,
    });
});
